// extracted by mini-css-extract-plugin
module.exports = {"belletop":"belle_belletop_3aIIy","scrollbox":"belle_scrollbox_2zB5f"};